import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import ByNewBusiness from "../components/ByNewBusiness";
import ByIndustry from "../components/ByIndustry";
import ByGeography from "../components/ByGeography";
import { colors } from "@mui/material";
function BusinessGeneration() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [generatedOptions, setGeneratedOptions] = useState([]);
  const [qualityOptions, setQualityOptions] = useState([]);
  const [opGeneratedOptions, setOpGeneratedOptions] = useState([]);
  const [sectorGeneratedOptions, setSectorGeneratedOptions] = useState([]);
  const [newBusinessOptions, setNewBusinessOptions] = useState([]);
  const [sectorNewBusinessOptions, setSectorNewBusinessOptions] = useState([]);
  const [regionNewBusinessOptions, setRegionNewBusinessOptions] = useState([]);
  const [newBusinessBUOptions, setNewBusinessBUOptions] = useState([]);
  const [optionsBUData, setOptionsBUData] = useState([]);
  const [selectedBU, setSelectedBU] = useState(null);
  const { setGlobalLoading, token } = useOutletContext();

  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_business_generation/`,
        {
            params: { year: selectedYear},
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setGeneratedOptions(response.data.generated_list || []);
        setQualityOptions(response.data.quality_business || []);
        setOpGeneratedOptions(response.data.op_generated_list || []);
        setSectorGeneratedOptions(response.data.sector_generated_list || []);
        setNewBusinessOptions(response?.data?.new_business_data?.[0] || {});
        setSectorNewBusinessOptions(response.data.new_business_sector || []);
        setRegionNewBusinessOptions(response.data.new_business_region || []);
        setNewBusinessBUOptions(response.data.new_business_bu_data || []);

        setSelectedBU(null);
        setOptionsBUData([]);
        setNewBusinessBUOptions(response.data.new_business_bu_data || []);
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }

        if (response.data.new_business_bu_data?.length > 0) {
            const firstBU = response.data.new_business_bu_data[0].id;
            fetchBUNewBusinessInvoices(firstBU);
          }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

useEffect(() => {
  if (token && selectedYear) {
    fetchOptions();
  }
}, [token, selectedYear]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

  const groupedData = generatedOptions.reduce((acc, item) => {
    if (!acc[item.partner_name]) {
      acc[item.partner_name] = [];
    }
    acc[item.partner_name].push(item);
    return acc;
  }, {});

  const opGroupedData = opGeneratedOptions.reduce((acc, item) => {
    if (!acc[item.partner_name]) {
      acc[item.partner_name] = [];
    }
    acc[item.partner_name].push(item);
    return acc;
  }, {});

  const sectorGroupedData = sectorGeneratedOptions.reduce((acc, item) => {
    if (!acc[item.partner_name]) {
      acc[item.partner_name] = [];
    }
    acc[item.partner_name].push(item);
    return acc;
  }, {});


  const fetchBUNewBusinessInvoices = async (unitHeadId) => {
    try {
      setGlobalLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/reports/get_new_business_invoice_details`,
        {
          params: {
            year: selectedYear,
            unit_head_id: unitHeadId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setOptionsBUData(response.data.new_business_bu_invoices || []);
      setSelectedBU(unitHeadId);
    } catch (error) {
      console.error(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
      size: 70,
      Cell: ({ row }) => (
        <Link
          to={`/order/view/${row.original.invoice_id}`}
        >
          {decodeHtml(row.original.name)}
        </Link>
      ),
    },
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 70,
      Cell: ({ row }) => (
        <Link to={`/role/view/${row.original.role_id}`}>
          {decodeHtml(row.original.role_name)}
        </Link>
      ),
    },
    {
      accessorKey: "company_name",
      header: "Clients",
      size: 70,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 40,
    },
    {
      accessorKey: "invoice_number",
      header: "Invoice Number",
      size: 70,
    },
    {
      accessorKey: "issue_date",
      header: "Issued On",
      size: 70,
    },
    {
      accessorKey: "revenue",
      header: "Total(INR)",
      size: 70,
      Cell: ({ row }) => currency_converter_inr(row.original.revenue),
    },
  ];

  const totalRevenueRegion = regionNewBusinessOptions.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0
  ); 
  const totalRevenueSector = sectorNewBusinessOptions.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0
  );

  const totalNewBusinessRevenueBU = newBusinessBUOptions.reduce(
    (sum, row) => sum + Number(row.new_business || 0),
    0
  );

  const totalRevenueBU = newBusinessBUOptions.reduce(
    (sum, row) => sum + Number(row.total_revenue || 0),
    0
  );

  
    return (
        <>
       <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 180px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 180px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 280px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Business Generation</h4>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "580px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1">Partners</th>
                                <th className="sticky-col-2">-</th>
                                <th className="sticky-col-3">Revenue Total</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                              {Object.entries(groupedData).map(([partner, rows], index) => (
                                <React.Fragment key={index}>
                                  {rows.map((row, rowIndex) => (
                                    <tr key={`${index}-${rowIndex}`}>
                                      {rowIndex === 0 && (
                                        <td
                                          rowSpan={rows.length}
                                          className="sticky-col-1"
                                          style={{
                                            verticalAlign: "middle",
                                            fontWeight: "500",
                                            minWidth: "180px",
                                          }}
                                        >
                                          {partner}
                                        </td>
                                      )}

                                      <td className="sticky-col-2">{row.row_type}</td>
                                      <td className="sticky-col-3">{formatNumber(row.total)}</td>
                                      <td>{formatNumber(row.Q1)}</td>
                                      <td>{formatNumber(row.Q2)}</td>
                                      <td>{formatNumber(row.Q3)}</td>
                                      <td>{formatNumber(row.Q4)}</td>

                                      <td>{formatNumber(row.Apr)}</td>
                                      <td>{formatNumber(row.May)}</td>
                                      <td>{formatNumber(row.Jun)}</td>
                                      <td>{formatNumber(row.Jul)}</td>
                                      <td>{formatNumber(row.Aug)}</td>
                                      <td>{formatNumber(row.Sep)}</td>
                                      <td>{formatNumber(row.Oct)}</td>
                                      <td>{formatNumber(row.Nov)}</td>
                                      <td>{formatNumber(row.Decr)}</td>
                                      <td>{formatNumber(row.Jan)}</td>
                                      <td>{formatNumber(row.Feb)}</td>
                                      <td>{formatNumber(row.Mar)}</td>
                                    </tr>
                                  ))}

                                  {/* Separator like screenshot */}
                                  <tr>
                                    <td
                                      colSpan="19"
                                      style={{
                                        padding: 0,
                                        borderBottom: "2px solid #7aa6ff",
                                      }}
                                    />
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div> 

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <div class="card-title mt-5">Quality of Business Generated</div>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1"></th>
                                <th>Closed</th>
                                <th>Board Level</th>
                                <th>Non Board</th>
                                <th>VoBT</th>
                                <th>Billed Comp</th>
                                <th>Total Fee</th>
                                <th>Average VoBT</th>
                                <th>Average Fee(%)</th>
                                <th>Average Fee%(VOBT)</th>
                                <th>ARPA</th>
                                <th>New Business</th>
                                <th>Total Revenue</th>
                            </tr>
                            </thead>

                            <tbody>
                            {qualityOptions.map((row, index) => (
                              <tr>
                                <td className="sticky-col-1">{row.unit_head}</td>
                                <td>{row.closed_assignments}</td>
                                <td>{row.board_closed}</td>
                                <td>{row.non_board_closed}</td>
                                <td>{formatNumber(row.vobt)}</td>
                                <td>{formatNumber(row.billed_comp)}</td>
                                <td>{formatNumber(row.total_fee)}</td>
                                <td>{formatNumber(row.average_vobt)}</td>
                                <td>{row.average_fee_percent}</td>
                                <td>{row.average_fee_percent_vobt}</td>
                                <td>{formatNumber(row.arpa)}</td>
                                <td>{formatNumber(row.new_business)}</td>
                                <td>{formatNumber(row.total_revenue)}</td>
                              </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <div class="card-title mt-5">Operating Partners Business Generated</div>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1">Operating Partners</th>
                                <th className="sticky-col-2">-</th>
                                <th className="sticky-col-3">Revenue Total</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                              {Object.entries(opGroupedData).map(([partner, rows], index) => (
                                <React.Fragment key={index}>
                                  {rows.map((row, rowIndex) => (
                                    <tr key={`${index}-${rowIndex}`}>
                                      {rowIndex === 0 && (
                                        <td
                                          rowSpan={rows.length}
                                          className="sticky-col-1"
                                          style={{
                                            verticalAlign: "middle",
                                            fontWeight: "500",
                                            minWidth: "180px",
                                          }}
                                        >
                                          {partner}
                                        </td>
                                      )}

                                      <td className="sticky-col-2">{row.row_type}</td>
                                      <td className="sticky-col-3">{formatNumber(row.total)}</td>
                                      <td>{formatNumber(row.Q1)}</td>
                                      <td>{formatNumber(row.Q2)}</td>
                                      <td>{formatNumber(row.Q3)}</td>
                                      <td>{formatNumber(row.Q4)}</td>

                                      <td>{formatNumber(row.Apr)}</td>
                                      <td>{formatNumber(row.May)}</td>
                                      <td>{formatNumber(row.Jun)}</td>
                                      <td>{formatNumber(row.Jul)}</td>
                                      <td>{formatNumber(row.Aug)}</td>
                                      <td>{formatNumber(row.Sep)}</td>
                                      <td>{formatNumber(row.Oct)}</td>
                                      <td>{formatNumber(row.Nov)}</td>
                                      <td>{formatNumber(row.Decr)}</td>
                                      <td>{formatNumber(row.Jan)}</td>
                                      <td>{formatNumber(row.Feb)}</td>
                                      <td>{formatNumber(row.Mar)}</td>
                                    </tr>
                                  ))}

                                  {/* Separator like screenshot */}
                                  <tr>
                                    <td
                                      colSpan="19"
                                      style={{
                                        padding: 0,
                                        borderBottom: "2px solid #7aa6ff",
                                      }}
                                    />
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div class="card-title mt-5">Sector Wise Business Generated</div>  
                        <div className="table-responsive" style={{ maxHeight: "600px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th className="sticky-col-1">Partners</th>
                                <th className="sticky-col-2">-</th>
                                <th className="sticky-col-3">Revenue Total</th>
                                <th className=""><NavLink to={`/report/sector_analysis/1`} style={{ color: "#f26522", textDecoration: "none" }}>BFSI/PE</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/2`} style={{ color: "#f26522", textDecoration: "none" }}>Infrastructure</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/3`} style={{ color: "#f26522", textDecoration: "none" }}>Consumer</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/4`} style={{ color: "#f26522", textDecoration: "none" }}>Communication</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/5`} style={{ color: "#f26522", textDecoration: "none" }}>Technology</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/7`} style={{ color: "#f26522", textDecoration: "none" }}>Healthcare</NavLink></th>
                                <th><NavLink to={`/report/sector_analysis/9`} style={{ color: "#f26522", textDecoration: "none" }}>Others</NavLink></th>
                            </tr>
                            </thead>

                            <tbody>
                              {Object.entries(sectorGroupedData).map(([partner, rows], index) => (
                                <React.Fragment key={index}>
                                  {rows.map((row, rowIndex) => (
                                    <tr key={`${index}-${rowIndex}`}>
                                      {rowIndex === 0 && (
                                        <td
                                          rowSpan={rows.length}
                                          className="sticky-col-1"
                                          style={{
                                            verticalAlign: "middle",
                                            fontWeight: "500",
                                            minWidth: "180px",
                                          }}
                                        >
                                          {partner}
                                        </td>
                                      )}

                                      <td className="sticky-col-2">{row.row_type}</td>
                                      <td className="sticky-col-3">{formatNumber(row.total)}</td>
                                      <td>{formatNumber(row.bfsi)}</td>
                                      <td>{formatNumber(row.infrastructure)}</td>
                                      <td>{formatNumber(row.consumer)}</td>
                                      <td>{formatNumber(row.commerce)}</td>
                                      <td>{formatNumber(row.technology)}</td>
                                      <td>{formatNumber(row.healthcare)}</td>
                                      <td>{formatNumber(row.others)}</td>
                                    </tr>
                                  ))}

                                  {/* Separator like screenshot */}
                                  <tr>
                                    <td
                                      colSpan="19"
                                      style={{
                                        padding: 0,
                                        borderBottom: "2px solid #7aa6ff",
                                      }}
                                    />
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

            </div>
        </div>
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">New Business</h4>
                </div>

                <div className="row">
                    <div className="col-md-4 col-xl-4 col-xxl-4">
                        <div class="card-title mt-2">New Business Development</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th></th>
                                <th>Total (in INR)</th>
                            </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>New Business 12 Months</td>
                                <td>{formatNumber(data?.new_business_data?.[0]?.new_business_12_months || 0)}</td>
                              </tr>
                               <tr>
                                <td>New Business 24 Months</td>
                                <td>{formatNumber(data?.new_business_data?.[0]?.new_business_24_months || 0)}</td>
                              </tr>
                               <tr>
                                <td>Total New Business</td>
                                <td>{formatNumber(data?.new_business_data?.[0]?.total_new_business || 0)}</td>
                              </tr>
                              <tr>
                                <td>New business Vs Total Revenue</td>
                                <td>{data?.new_business_data?.[0]?.new_business_percentage || 0}</td>
                              </tr>
                            </tbody>
                        </table>
                        </div>        
                    </div>

                    <div className="col-md-4 col-xl-4 col-xxl-4">
                        <div class="card-title mt-2">Revenue Sector Summary</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Contribution</th>
                                <th>Total (in INR)</th>
                            </tr>
                            </thead>

                            <tbody>
                            {sectorNewBusinessOptions.map((row, index) => (
                              <tr>
                                <td>{row.sector}</td>
                                <td>{formatNumber(row.total)}</td>
                              </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr>
                              <td style={{ backgroundColor: "#F5F5F5" }}>Total</td>
                              <td style={{ backgroundColor: "#F5F5F5" }}>{formatNumber(totalRevenueSector)}</td>
                            </tr>
                          </tfoot>
                        </table>
                        </div>        
                    </div>

                    <div className="col-md-4 col-xl-4 col-xxl-4">
                        <div class="card-title mt-2">Revenue Region Summary</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Contribution</th>
                                <th>Total (in INR)</th>
                            </tr>
                            </thead>

                            <tbody>
                            {regionNewBusinessOptions.map((row, index) => (
                              <tr>
                                <td>{row.region}</td>
                                <td>{formatNumber(row.total)}</td>
                              </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr>
                              <td style={{ backgroundColor: "#F5F5F5" }}>Total</td>
                              <td style={{ backgroundColor: "#F5F5F5" }}>{formatNumber(totalRevenueRegion)}</td>
                            </tr>
                          </tfoot>
                        </table>
                        </div>        
                    </div>
                </div>

               <div className="row mt-2 align-items-stretch">
                  <div className="col-md-4 col-xl-4 col-xxl-4 d-flex">
                    <div className="card-body border border-secondary rounded w-100 chart-box">
                      <ByNewBusiness chart_data={newBusinessOptions} />
                    </div>
                  </div>

                  <div className="col-md-4 col-xl-4 col-xxl-4 d-flex">
                    <div className="card-body border border-secondary rounded w-100 chart-box">
                      <ByIndustry chart_data={sectorNewBusinessOptions} />
                    </div>
                  </div>

                  <div className="col-md-4 col-xl-4 col-xxl-4 d-flex">
                    <div className="card-body border border-secondary rounded w-100 chart-box">
                      <ByGeography chart_data={regionNewBusinessOptions} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 col-xl-4 col-xxl-4">
                        <div class="card-title mt-4">BU New Business Summary</div>
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Unit Head</th>
                                <th>New Business</th>
                                <th>Total Generated</th>
                            </tr>
                            </thead>

                            <tbody>
                            {newBusinessBUOptions.map((row, index) => {
                              const rowStyle =
                                Number(selectedBU) === Number(row.id)
                                  ? { backgroundColor: "#b1c0d1" }
                                  : {};

                              return (
                                <tr key={index}>
                                  <td style={rowStyle}>
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        fetchBUNewBusinessInvoices(row.id);
                                      }}
                                      style={{
                                        color: "#0d6efd",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {row.unit_head}
                                    </a>
                                  </td>

                                  <td style={rowStyle}>
                                    {formatNumber(row.new_business)}
                                  </td>

                                  <td style={rowStyle}>
                                    {formatNumber(row.total_revenue)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                            <tfoot>
                            <tr>
                              <td style={{ backgroundColor: "#F5F5F5" }}>Total</td>
                              <td style={{ backgroundColor: "#F5F5F5" }}>{formatNumber(totalNewBusinessRevenueBU)}</td>
                              <td style={{ backgroundColor: "#F5F5F5" }}>{formatNumber(totalRevenueBU)}</td>
                            </tr>
                          </tfoot>
                        </table>
                        </div>        
                    </div>
                  <div className="col-md-8 col-xl-8 col-xxl-8">
                    <div className="card-title mt-4">
                      {selectedBU
                        ? `New Business Invoice Details`
                        : `Click a Unit Head to view invoices`}
                    </div>
                      <div className="custom-datatable-filter table-responsive">
                        <div className="row p-1 mt-0">
                          {optionsBUData.length > 0 && (
                            <MaterialReactTable
                              columns={columns}
                              data={optionsBUData}
                              enableGrouping
                              initialState={{
                                density: "compact",
                                grouping: ["company_name"], // group by company_name
                                expanded: true, // expand groups by default
                                pagination: { pageSize: 100 },
                                columnOrder: [
                                  "name",
                                  "role_name",
                                  "company_name",
                                  "status",
                                  "invoice_number",
                                  "issue_date",
                                  "revenue",
                                ],
                                columnPinning: {
                                  left: [], // 👈 no pinned columns
                                  right: [],
                                },
                              }}
                            />
                          )}
                        </div>
                      </div>
                  </div>
                </div>            

            </div>
        </div>
        </>
    );
}

export default BusinessGeneration;
